$(document).ready(function() {
    $('.shopify-section-group-header-group, .section-header-utility').wrapAll('<div class="shopify-section-header-group-main"></div>');
   $('.productView-product .download-file-button').wrapAll('<div class="download-file-button-container"></div>');

    $(".abstract-cit").on("click", function(){
       $(this).toggleClass("visible-now");
      //$(this).slideToggle();
    })
    $("button.contact-type-sub-bt").on("click", function(){
      var getVal = $(this).text();
      console.log(getVal)
      $("input.form-control.contact-support-type").val($(this).text());
      $(".contact-us-page-cstm").addClass("active-contact");
    })
  $("a.back-button").on("click", function(){
    $(".contact-us-page-cstm").removeClass("active-contact"); 
  })
});



$(document).ready(function() {
    $('.toggleLink').click(function(event) {
        // Prevent the default action of the click event
        event.preventDefault();
        
        // Find the associated toggle-content
        var $currentContent = $(this).closest('.toggle-title').next('.toggle-content');

        // Check if the current content is already visible
        var isVisible = $currentContent.is(':visible');

        // Close any other open toggle-content and remove the is-open class from all toggleLinks
        $('.toggle-content').slideUp(300);
        $('.toggleLink.is-open').removeClass('is-open');

        // If the current content was not visible, toggle it and add the is-open class
        if (!isVisible) {
            $currentContent.slideDown(300);
            $(this).addClass('is-open'); // Add is-open class to the clicked toggleLink
        }
    });
});